import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import BrowserNotifier from '@/components/BrowserNotifier.vue';
import CompleteUserProfileDialog from '@/components/v2/CompleteUserProfileDialog.vue';
import query from '@/plugins/graphql/queries/me.gql';
import NotifierSubscription from '@/plugins/graphql/subscriptions/v2/browser-notification-create.gql';
import { Mutation } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import LogoutMixin from '@/helpers/mixins/LogoutMixin';
import AffiliateMixin from '@/helpers/mixins/AffiliateMixin';
import NetworkDistributorMixin from '@/helpers/vue_mixins/v2/network_distributor/NetworkDistributorMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { startCase, camelCase, pick } from 'lodash';
import { UserType } from '@/helpers/entities/enums/UserType';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
const opts = { namespace: NAV_DRAWER };
let UserSettings = class UserSettings extends Mixins(ViewportSizeMixin, LogoutMixin, AffiliateMixin, NetworkDistributorMixin, Mixins(RouterParamsAppMixin, RouterPathMixin)) {
    constructor() {
        super(...arguments);
        this.notifierMessage = '';
        this.notifierTitle = '';
        this.notifierUuid = '';
        this.notifierLink = '';
        this.hasIncompleteProfile = false;
    }
    userSettings() {
        return [
            /* {
                text: 'Apps',
                key: 'apps',
                icon: 'list',
                href: '#',
                click: this.goToAppsDashboard,
              }, */
            {
                text: 'My Account',
                key: 'profile',
                icon: 'account_circle',
                click: this.redirectToUserProfile,
                hidden: false,
            },
            {
                text: 'Sales Partner Manager',
                key: 'salesPartner',
                icon: '',
                click: this.redirectToAffiliate,
                hidden: this.isClient(),
            },
            {
                text: 'Logout',
                key: 'logout',
                icon: 'exit_to_app',
                click: this.logoutAccount,
                hidden: false,
            },
        ];
    }
    isClient() {
        if (this.me?.affiliateCode && this.me?.role === 'reseller') {
            return false;
        }
        return true;
    }
    logoutAccount() {
        // const token = sessionStorage.getItem(AUTH_TOKEN);
        // Temporary fix for login issue
        // this.destroyToken(token);
        this.logout();
    }
    goToAppsDashboard() {
        this.closeDrawer();
        this.$router.push('/apps');
    }
    showMobileUserSettings(user) {
        if (this.xsOnly) {
            this.showUserSettings();
            this.setCurrentUser(user);
        }
    }
    get avatarSize() {
        if (this.xsOnly) {
            return '30';
        }
        return '';
    }
    redirectToAffiliate() {
        this.closeDrawer();
        this.goToAffiliate(this.me.uuid);
    }
    redirectToUserProfile() {
        this.$router.push('/profile');
    }
    mounted() {
        if (window.Notification && Notification.permission !== 'denied') {
            Notification.requestPermission();
        }
    }
};
__decorate([
    Mutation('showUserSettings', opts)
], UserSettings.prototype, "showUserSettings", void 0);
__decorate([
    Mutation('setCurrentUser', opts)
], UserSettings.prototype, "setCurrentUser", void 0);
UserSettings = __decorate([
    Component({
        components: { BrowserNotifier, CompleteUserProfileDialog },
        apollo: {
            me: {
                query,
                skip() {
                    return !this.$store.state.session.token;
                },
                update({ me }) {
                    const meValues = Object.values(pick(me, ['firstName', 'lastName', 'birthdate', 'contactNumber', 'businessEmailAddress']));
                    if (meValues.some((val) => !val) &&
                        me.role !== UserType.Affiliate &&
                        !this.isAccountPage() &&
                        !this.isDiy()) {
                        this.hasIncompleteProfile = true;
                    }
                    else {
                        this.hasIncompleteProfile = false;
                    }
                    return me;
                },
                subscribeToMore: {
                    document: NotifierSubscription,
                    updateQuery(previousResult, { subscriptionData }) {
                        const { browserNotificationCreate } = subscriptionData.data;
                        const { bundleKey, uuid } = browserNotificationCreate.app;
                        const name = startCase(camelCase(browserNotificationCreate.pageRecipient.name));
                        const message = `${name} ${browserNotificationCreate.message}`;
                        this.notifierTitle = browserNotificationCreate.app.name;
                        this.notifierMessage = message;
                        this.notifierUuid = browserNotificationCreate.uuid;
                        this.notifierLink = `${window.location.origin}/apps/${bundleKey}/${uuid}/overview`;
                        return previousResult;
                    },
                },
            },
        },
    })
], UserSettings);
export default UserSettings;
